import { render, staticRenderFns } from "./printPeriodicReport.vue?vue&type=template&id=68faed88&"
import script from "./printPeriodicReport.vue?vue&type=script&lang=js&"
export * from "./printPeriodicReport.vue?vue&type=script&lang=js&"
import style0 from "./printPeriodicReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports